import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { setNeedMoreInfo } from "@portal/redux/reducers/riskLevelReducer";
import { SendMessageForResize } from "../components/helpers/SendMessageForResize";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent } from "../components/footer";
import { RefreshInfo } from "./info";
import { TextLine } from "@portal/components/atoms/v2/textLine";

export const RefreshPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const { request } = useAppSelector(state => state.persisted.riskLevel);
  const [selectedOption, setSelectedOption] = useState<number | null>(SetInitialOption(request.needMoreInfo));
  const isButtonDisabled = request.needMoreInfo === null;
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_3_A, texts.PAGE_3_B];
  const showToggleBox = selectedOption === 1;

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    const result = selectedOption === 0 ? false : true;
    dispatch(setNeedMoreInfo(result));
    SendMessageForResize();
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_3_SUBHEADER}</Typography>
        <TextLine />
        <SelectionBoxComponent options={options} selectedOption={selectedOption} onSelectionClick={OnSelectionClick} />
        {showToggleBox && <RefreshInfo isDefaultLanguage={isDefaultLanguage} />}
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};

export const SetInitialOption = (needMoreInfo: boolean | null) => {
  if (needMoreInfo === null) return null;
  return needMoreInfo ? 1 : 0;
};
